export const PHONE_DISPLAY = "0895 410 271";
export const PHONE_TEL = "tel:+359895410271";
export const ADDRESS = "ж.к. Овчарски, бул. „България“ 226, 6300 Хасково";
export const MAPS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=" +
  encodeURIComponent("ж.к. Овчарски, бул. България 226, 6300 Хасково, България");
export const SHOP_URL = "https://www.akumulator.pro/";

export const WORKING_HOURS = [
  { day: "Понеделник", hours: "9:00 – 18:00" },
  { day: "Вторник", hours: "9:00 – 18:00" },
  { day: "Сряда", hours: "9:00 – 18:00" },
  { day: "Четвъртък", hours: "9:00 – 18:00" },
  { day: "Петък", hours: "9:00 – 18:00" },
  { day: "Събота", hours: "Затворено" },
  { day: "Неделя", hours: "Затворено" },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
